export const APP_STORE_LINK = 'https://apps.apple.com/RU/app/id1005018803?mt=8';
